import type { Point2d } from "."
import { findMinMaxPoints } from "."

export const findCenterOfPoints = (...nodes: Point2d[]): Point2d => {
  const { min, max } = findMinMaxPoints(...nodes)

  return {
    x: (min.x + max.x) / 2,
    y: (min.y + max.y) / 2,
  }
}
